import { createContext, useContext } from "react";
import useFindInformationStore from "./hook";

export const FindInformationContext = createContext({
  locations: {
    data: [],
    loading: false,
    setLoading: () => { },
    hasError: false,
    setHasError: () => { },
    showFilters: false,
    fetch: () => { },
    fetchForm: () => { },
    setShowFilters: () => { },
    selectOptions: [],
    setSelectOptions: () => { },
    defaultActiveFilters: null,
    setDefaultActiveFilters: () => { },
    form: {},
  },
  entities: {
    loading: false,
    data: [],
    setLoading: () => { },
    fetch: () => { },
    fetchForm: () => { },
    hasError: false,
    form: {},
    setHasError: () => { },
    showFilters: false,
    setShowFilters: () => { },
    selectOptions: [],
    setSelectOptions: () => { },
    defaultActiveFilters: null,
    setDefaultActiveFilters: () => { },
  },
  defaultTab: null,
  setDefaultTab: () => { },
});

export const FindInformationProvider = ({ children }) => {
  const value = useFindInformationStore();

  return (
    <FindInformationContext.Provider value={value}>
      {children}
    </FindInformationContext.Provider>
  )
}

export const useFindInformation = () => {
  const value = useContext(FindInformationContext);
  return value;
}
